import { render, staticRenderFns } from "./activityPage.vue?vue&type=template&id=3e16f260&scoped=true"
import script from "./activityPage.vue?vue&type=script&lang=js"
export * from "./activityPage.vue?vue&type=script&lang=js"
import style0 from "./activityPage.vue?vue&type=style&index=0&id=3e16f260&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e16f260",
  null
  
)

export default component.exports